module.exports = __webpack_public_path__ + "static/img/ws_ds_mp.f68e65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/ws_ds_mp.png
// module id = w3UB
// module chunks = 0